import { Inject, Injectable } from '@angular/core';
import {
  DwCacheService,
  DwContextService,
  DwMetaDataActionConfigService,
  DwMetaDataListConfig,
  DwMetaDataListPreferenceHierarchy,
  DwMetaDataListService,
  DwMetaDataService,
  DwMetaDataServiceToken,
  DwOrmDataService,
  DwOrmDataServiceToken,
  DwUiConfigService,
  DwUIMetaDataConfig,
  DwUIMetaDataConfigToken
} from '@devwareapps/devware-cap';

@Injectable()
export class AviatorMetadataListService extends DwMetaDataListService {
  constructor(
    @Inject(DwOrmDataServiceToken) dwOrmDataService: DwOrmDataService,
    @Inject(DwMetaDataServiceToken) dwMetaDataService: DwMetaDataService,
    @Inject(DwUIMetaDataConfigToken) uiMetaDataConfig: DwUIMetaDataConfig,
    uiConfigService: DwUiConfigService,
    dwCacheService: DwCacheService,
    dwMetaDataActionConfigService: DwMetaDataActionConfigService,
    dwContextService: DwContextService
  ) {
    super(
      dwOrmDataService,
      dwMetaDataService,
      uiMetaDataConfig,
      uiConfigService,
      dwCacheService,
      dwMetaDataActionConfigService,
      dwContextService
    );
  }

  buildConfig(listPreferenceHierarchy: DwMetaDataListPreferenceHierarchy): DwMetaDataListConfig {
    const config = super.buildConfig(listPreferenceHierarchy);

    config.filters = Array.isArray(config.filters) ? config.filters : [];
    config.actionPreferencesByMode = config.actionPreferencesByMode || {};

    return config;
  }
}
